import { IconName } from "@inflow/icons"

import Icon from "@/globalComponents/atoms/Icon"

import styles from "./index.module.css"

export type ProductSpecifications =
  | { icon: IconName; copy: string }[]
  | string[]

function ProductDetails(props: { details: ProductSpecifications }) {
  return (
    <ul className={styles.productDetails}>
      {props.details.map((detail, index) => {
        if (typeof detail === "string") {
          return <li key={index}>{detail}</li>
        } else if (detail.copy) {
          return (
            <li key={index} data-has-icon>
              <Icon name={detail.icon} slot="left" />
              {detail.copy}
            </li>
          )
        }
      })}
    </ul>
  )
}

export default ProductDetails
